import { EstateInterface } from "@/types/EstateInterface";

export const getEoiLogoUrl = (estate: EstateInterface, businessId: string | null): string => {
  if(!businessId) return estate?.logoUrl;
  if(!businessId || !estate?.collaboratorBusiness) return estate?.logoUrl;
  if(businessId === estate?.collaboratorBusiness[0]?._id) {
    return estate?.collaboratorBusiness[0].branding.logoUrl
  }
  return estate?.logoUrl
}